
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicPrepayCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TPrepayCard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annual_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annual_fee_cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicImage"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"monthly_cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan_features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicPlanFeature"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"purchase_cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUrl"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullPrepayCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TPrepayCard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicPrepayCard"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annual_fee_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bank_account_required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chip_and_pin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit_check_required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max_single_topup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthly_inactive_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthly_inactive_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stamp_duty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_bank_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_cheque_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_creditcard_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_instore_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_laser_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topup_tiers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tx_atm_cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tx_forex_cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tx_instore_free"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tx_instore_text"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":792}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/shared/image\"\n#import \"@/graphql/fragments/shared/plan-feature\"\n#import \"@/graphql/fragments/shared/url\"\n\nfragment BasicPrepayCard on TPrepayCard {\n  annual_fee\n  annual_fee_cost\n  brand\n  code\n  logo {\n    ...BasicImage\n  }\n  monthly_cost\n  name\n  plan_features {\n    ...BasicPlanFeature\n  }\n  purchase_cost\n  slug\n  url {\n    ...BasicUrl\n  }\n}\n\nfragment FullPrepayCard on TPrepayCard {\n  ...BasicPrepayCard\n  annual_fee_text\n  bank_account_required\n  chip_and_pin\n  credit_check_required\n  max_single_topup\n  min_age\n  monthly_inactive_fee\n  monthly_inactive_text\n  stamp_duty\n  topup_bank_text\n  topup_cheque_text\n  topup_creditcard_text\n  topup_instore_text\n  topup_laser_text\n  topup_tiers\n  tx_atm_cost\n  tx_forex_cost\n  tx_instore_free\n  tx_instore_text\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/image").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/plan-feature").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/url").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BasicPrepayCard"] = oneQuery(doc, "BasicPrepayCard");
        
        module.exports["FullPrepayCard"] = oneQuery(doc, "FullPrepayCard");
        
